import { render, staticRenderFns } from "./gProductList.vue?vue&type=template&id=d18c02d8&scoped=true&"
import script from "./gProductList.vue?vue&type=script&lang=js&"
export * from "./gProductList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d18c02d8",
  null
  
)

export default component.exports